import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const resetDeliverableMutation = graphql`
  mutation ResetDeliverableMutation($input: ResetDeliverableInput!) {
    resetDeliverable(input: $input) {
      updatedDeliverable {
        state
      }
    }
  }
`;

export default (id, callback) => {
  const config = {
    mutation: resetDeliverableMutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.resetDeliverable);
    }
  };

  commitMutation(getEnvironment(), config);
};
